/**
 * <StatsTileCard> Component
 */
import PropTypes from 'prop-types';
/** @jsx jsx this comment is required for Storybook to render */
import { css, jsx } from '@emotion/core';
import {
  breakpoints,
  colors,
  fontSizes,
  unitConverter as uc,
} from '../../../styles/base';
import { Heading3 } from '../../atoms/Headings/Headings';
import Card from '../../atoms/Card/Card';
import Text from '../../atoms/Text/Text';
import Link from '../../atoms/Link/Link';

const StatsTileCard = ({
  cardBackGroundcolor = 'white',
  link,
  statsDescription,
  statsHeading,
}) => {
  const cardColors = {
    gray: colors.darkGray.three,
    accent: colors.accent,
    primary: colors.primary,
    white: colors.white,
  };

  const statsTileCardCss = css`
    background-color: ${cardColors[cardBackGroundcolor]};
  `;

  const noHeadingCss = css`
    width: ${uc('300px')};
    max-width: unset !important;
  `;
  const linkCss = css`
    color: ${colors.accent};
    font-size: ${fontSizes.twenty};

    @media (${breakpoints.tablet}) {
      font-size: ${fontSizes.eighteen};
    }

    &:hover {
      color: ${colors.accentHover};
    }
  `;

  return (
    <Card css={statsTileCardCss}>
      {statsHeading && (
        <Heading3
          fontSize={fontSizes.twenty}
          color={
            cardBackGroundcolor === 'white' ? colors.primary : colors.white
          }
        >
          {statsHeading}
        </Heading3>
      )}
      <Text
        css={statsHeading ? '' : noHeadingCss}
        color={
          cardBackGroundcolor === 'white' ? colors.darkGray.two : colors.white
        }
      >
        {statsDescription}
      </Text>
      {link && (
        <Link css={linkCss} to={link}>
          {link.text}
        </Link>
      )}
    </Card>
  );
};

StatsTileCard.propTypes = {
  statsHeading: PropTypes.string.isRequired,
  statsDescription: PropTypes.string.isRequired,
  link: PropTypes.shape({ text: PropTypes.string }),
  cardBackGroundcolor: PropTypes.string,
};

StatsTileCard.defaultProps = {
  cardBackGroundcolor: colors.white,
  link: null,
};

export default StatsTileCard;
